import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';

@Component({
  templateUrl: './sso-calendario-registrar.component.html',
  styleUrls: ['./sso-calendario-registrar.component.css']
})
export class SsoCalendarioRegistrarComponent implements OnInit {
  fechaActual:Date;
  disableFechaNotificacion:boolean;
  disableFechaInicio:boolean;
  disableFechaFin:boolean;
  constructor(
    public dialogRef: MatDialogRef<SsoCalendarioRegistrarComponent>,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public data: CalendarioSsoModel,
    private service: CalendarioSsoService
  ) { 
    this.fechaActual = new Date();
    this.disableFechaNotificacion = new Date()>new Date(this.data.fechaNotificacion);
    this.disableFechaInicio = new Date()>new Date(this.data.fechaInicio);
    this.disableFechaFin = new Date()>new Date(this.data.fechaFin);
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  EsValido(): boolean {
    return this.data.comentarioAmpliacion !== '' && this.data.fechaNotificacion !== null && this.data.fechaInicio !== null && this.data.fechaFin !== null && this.data.fechaCierre !== null;
  }

  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      
      
      if (this.data.fechaNotificacion > this.data.fechaInicio) {
        this.alertDialogService.open('La fecha de notificación no puede ser mayor a la fecha de inicio');
      } else {
          this.service.update(this.data).subscribe((result: ActionResultModel) => {
            console.log(result);
            if(result.type!=eTypeResult.SUCCESS){
              this.alertDialogService.open(result.message);
            }else{
              this.dialogRef.close(this.data);
            }
          });
        
      }
    }
  }

}
